// Temporary mock auth service for development
// This simulates the backend auth while MongoDB is being set up

import { authService } from './auth';

const mockUsers = [
  {
    email: 'hola@alerecafe.com',
    password: '1234567',
    nombre: 'Administrador',
    role: 'admin' as const
  },
  {
    email: 'baristas@alerecafe.com',
    password: 'AlereCafe!',
    nombre: 'Barista',
    role: 'user' as const
  }
];

// Override the login method temporarily
(authService as any).login = async (credentials: { email: string; password: string }) => {
  const user = mockUsers.find(u => u.email === credentials.email && u.password === credentials.password);
  
  if (!user) {
    throw new Error('Credenciales inválidas');
  }
  
  const mockToken = btoa(`${user.email}:${Date.now()}`);
  const response = {
    success: true,
    token: mockToken,
    user: {
      email: user.email,
      nombre: user.nombre,
      role: user.role
    }
  };
  
  // Save to localStorage
  localStorage.setItem('authToken', mockToken);
  localStorage.setItem('user', JSON.stringify(response.user));
  
  // Set user in auth service
  (authService as any).token = mockToken;
  (authService as any).user = response.user;
  
  return response;
};

// Override verify token
(authService as any).verifyToken = async () => {
  const token = localStorage.getItem('authToken');
  const userStr = localStorage.getItem('user');
  
  if (token && userStr) {
    const user = JSON.parse(userStr);
    (authService as any).token = token;
    (authService as any).user = user;
    return true;
  }
  
  return false;
};

export { authService as mockAuthService };